import {AfterViewInit, Component, OnInit, ViewChild ,ViewContainerRef, Directive} from '@angular/core';
import { Http, Response } from "@angular/http";
import { S3Service,CognitoCallback } from '../../service/s3.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { UserLoginService } from "../../service/user-login.service";
import {CognitoUtilService, LoggedInCallback, Callback } from "../../service/cognito-util.service";
import {UserParametersService} from "../../service/user-parameters.service";
import {AwsUtilService} from "../../service/aws-util.service";
import { News } from '../../shared/news'
import { MatDialog, MatDialogRef, MatListModule } from '@angular/material';
import { AddNewsDialogComponent } from './addNewsDialog.component';
import { Router } from "@angular/router";
import { DialogsService } from '../../service/dialogs.service';
import { AuthService } from '../../service/auth.service';
import 'rxjs/add/operator/map'
//@Directive({selector: 'p-editor'})


@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit  {
  newsArray:News[] = [];
  newsArray1:News[] = [];
  //newsArray1 = JSON.parse("./../../../assets/json/uutiset.json");
  userGroup: string = '';
  loading = false;
  isAuthenticated = false;  
  isLogged: boolean = false;
//  @ViewChild("p-editor")

  name:string = "uutiset.json";
  constructor( private http: Http, public s3Service: S3Service,public userService: UserLoginService, private viewContainerRef: ViewContainerRef,
     public userParams: UserParametersService, public router: Router,
    public cognitoUtil: CognitoUtilService,  public awsUtil: AwsUtilService, private dialogsService: DialogsService,
    public dialog: MatDialog, private authService: AuthService ) { 
      
  }
  

  ngOnInit() {
    //this.userService.isAuthenticated(this);
    console.log('NewsComponent ngOnInit()' );
    this.http
    .get("/assets/json/uutiset.json")
    .map(data => data.json() as Array<News>)
    .subscribe(data => {
      this.newsArray1 = data;
      console.log(data);
    });

    this.authService.userGroup.subscribe((userGroup) => {
      this.userGroup = userGroup;
      console.log('NewsComponent userGroup: ',this.userGroup);
    });

   // this.authService.initAuth();
  }

}
//public upload (content, name, callback: uploadCallBack){


// WEBPACK FOOTER //
// ./src/app/public/news/news.component.ts